"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileField = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const GetApp_1 = __importDefault(require("@material-ui/icons/GetApp"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const file_field_styles_1 = require("./file-field-styles");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const files_context_1 = require("../../common/files/files-context");
const text_field_1 = require("../text-field/text-field");
const snackbar_context_1 = require("../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../composite/snackbar/snackbar-types");
function FileField({ form, value, onChange, disabled, showUpload = true, showClear = true, accept = [], customDownloadUrl, autoFocus, }) {
    var _a;
    const classes = file_field_styles_1.useStyles();
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const intl = react_intl_1.useIntl();
    const { uploadFile, getFileUrl } = react_1.useContext(files_context_1.FilesContext);
    const handleUpload = event_callback_hook_1.useEventCallback(async (event) => {
        const input = event.currentTarget;
        const files = event.currentTarget.files;
        if (files.length === 0) {
            onChange(null);
            return;
        }
        const file = files[0];
        /**
         * Check the extension of a file and show error message
         * if not included in the accept array
         */
        const extensionIsValid = Boolean(accept.find((ext) => file.name.endsWith(ext)));
        if (accept.length && !extensionIsValid) {
            onChange(null);
            const message = intl.formatMessage({
                id: 'EAS_FILES_MSG_ERROR_FILE_TYPE',
                defaultMessage: 'Nepovolený typ souboru. Povolené hodnoty jsou: {fileTypes}',
            }, {
                fileTypes: accept.join(','),
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
            return;
        }
        const fileRef = await uploadFile(file);
        /*
          Reset file input, so one can load the same file again with trigering the onChange event.
          The event will not be triggered otherwise for the same file.
        */
        input.value = null;
        if (fileRef !== undefined) {
            onChange(fileRef);
        }
        else {
            onChange(null);
        }
    });
    const handleRemove = event_callback_hook_1.useEventCallback(() => {
        onChange(null);
    });
    return (react_1.default.createElement(text_field_1.TextField, { form: form, autoFocus: autoFocus, disabled: true, value: (_a = value === null || value === void 0 ? void 0 : value.name) !== null && _a !== void 0 ? _a : '', startAdornment: react_1.default.createElement(react_1.default.Fragment, null,
            showUpload && !disabled && (react_1.default.createElement(Button_1.default, { size: "small", classes: { root: classes.uploadButton }, disabled: disabled, variant: "contained", component: "label" },
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_FILE_BTN_SELECT", defaultMessage: "V\u00FDb\u011Br" })),
                react_1.default.createElement("input", { type: "file", accept: accept.join(','), style: { display: 'none' }, onChange: handleUpload }))),
            value && (react_1.default.createElement(Button_1.default, { download: true, size: "small", classes: { root: classes.downloadButton }, variant: "contained", href: customDownloadUrl ? customDownloadUrl : getFileUrl(value.id) },
                react_1.default.createElement(GetApp_1.default, null))),
            showClear && value && !disabled && (react_1.default.createElement(Button_1.default, { size: "small", classes: { root: classes.downloadButton }, variant: "contained", onClick: handleRemove, disabled: disabled },
                react_1.default.createElement(Clear_1.default, null)))) }));
}
exports.FileField = FileField;
//# sourceMappingURL=file-field.js.map